'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulationContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class2, _temp;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _cloner = require('cloner');

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _roundEntity = require('round-entity');

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

var _simDomainStore = require('sim-domain-store');

var _simDomainStore2 = _interopRequireDefault(_simDomainStore);

var _configurationEntity = require('configuration-entity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RegisteredShellContentModel = _configurationEntity.ContentModels.RegisteredShellContentModel;
var SimulationContentModel = exports.SimulationContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.shallow, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, (_class = (_temp = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(SimulationContentModel, _BaseContentModel);

  function SimulationContentModel() {
    (0, _classCallCheck3.default)(this, SimulationContentModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimulationContentModel.__proto__ || (0, _getPrototypeOf2.default)(SimulationContentModel)).apply(this, arguments));

    _this.Editor = _editor2.default;
    _this.Component = _component2.default;

    _initDefineProp(_this, '_options', _descriptor, _this);

    _initDefineProp(_this, 'lastSaved', _descriptor2, _this);

    _initDefineProp(_this, 'lastPublished', _descriptor3, _this);

    _initDefineProp(_this, 'willPublish', _descriptor4, _this);

    _initDefineProp(_this, 'shellType', _descriptor5, _this);

    _initDefineProp(_this, 'shell', _descriptor6, _this);

    _initDefineProp(_this, 'displayName', _descriptor7, _this);

    _initDefineProp(_this, 'rounds', _descriptor8, _this);

    (0, _mobx.when)(function () {
      return _this.$parent.hasHydrated;
    }, function () {
      // auto create shell when shellType is chosen
      if (!_this.shell) {
        (0, _mobx.reaction)(function () {
          return _this.shellType;
        }, function (shellType, rxn) {
          if (!shellType) return;
          _this.createShell();
          _this.saveEntity();
          _this.shell.saveEntity();
          rxn.dispose();
        }, { fireImmediately: true });
      }
    });
    return _this;
  }
  // @observable @deepBind meta = {
  //   shellType: {
  //     get readonly(){
  //       return !this.isNew
  //     }
  //   },
  //   "displayName": {
  //     required: true
  //   }
  // }


  (0, _createClass3.default)(SimulationContentModel, [{
    key: 'saveEntity',
    value: function saveEntity() {
      var _this2 = this;

      var ref = this.lastSaved;
      this.lastSaved = +new Date();
      this._saveEntity(null, function (err) {
        return _this2.lastSaved = ref;
      });
    }
  }, {
    key: 'exportToServer',
    value: function exportToServer(cb, errCbOrig) {
      var _this3 = this;

      if (this.anyDirty) return console.warn("cannot publish while dirty, please save");

      if (!this.readyToWriteToServer) {
        // save normally
        throw new Error("not ready to write to server!");
      }

      if (this.isSaving || this.isPublishing) return console.warn("already saving...");

      // so we know when this "isSaving"
      this.willPublish = +new Date();
      var simgate = this.$parent.simgate;
      var ref = this.lastPublished;
      this.lastPublished = +new Date();

      var errCb = function errCb(err) {
        _this3.lastPublished = ref;
        errCbOrig && errCbOrig(err);
      };

      // @TODO promises anyone???
      // add stateMachine first
      simgate.runTask(simgate.config.update, {
        path: 'simulation://stateMachine.flows.' + this.id,
        set: this._dtos.machine
      }, {
        // add scenario that references state machine
        onSuccess: function onSuccess() {
          return simgate.runTask(simgate.config.update, {
            path: 'simulation://scenarios.' + _this3.id,
            set: _this3._dtos.scenario
          }, {
            // add stateMachine first
            onSuccess: function onSuccess() {
              return simgate.runTask(simgate.config.update, {
                path: 'simulation' + (window.trcAppSettings.publishEnv || '') + '://stateMachine.flows.' + _this3.id,
                set: _this3._dtos.machine
              }, {
                // add scenario that references state machine
                onSuccess: function onSuccess() {
                  return simgate.runTask(simgate.config.update, {
                    path: 'simulation' + (window.trcAppSettings.publishEnv || '') + '://scenarios.' + _this3.id,
                    set: _this3._dtos.scenario
                  }, {
                    // commit to svn
                    onSuccess: function onSuccess() {
                      return simgate.runTask(simgate.config.commit, { path: "simulation" + (window.trcAppSettings.publishEnv || '') }, {
                        onSuccess: function onSuccess() {
                          return simgate.runTask(simgate.utils.execute, {
                            command: "authoring-commands://compile-state-machine",
                            arguments: '"..\\simulation' + (window.trcAppSettings.publishEnv || '') + '.json" -batch -config "Debug" -copySource true"'
                          }, {
                            onSuccess: function onSuccess() {
                              return _this3._saveEntity(cb, errCb);
                            },
                            onFailure: errCb
                          });
                        },
                        onFailure: errCb
                      });
                    },
                    onFailure: errCb
                  });
                },
                onFailure: errCb
              });
            },
            onFailure: errCb
          });
        },
        onFailure: errCb
      });
    }
  }, {
    key: 'createShell',
    value: function createShell() {
      this.shell = new this.ShellContentModel({ id: this.id + "_shell" + Math.floor(Math.random() * 100), shouldAutoPopulate: true });
    }
  }, {
    key: 'isPublishing',
    get: function get() {
      return this.willPublish > this.lastPublished;
    }

    /* slot( RegisteredShellContentModel ) */
    /* slot */
    /* @slot */
    /* @slot( RoundContentModel ) */
  }, {
    key: 'warnings',

    // /* @slot( BooleanContentModel ) */ @observable default = true
    // /* @slot( TeamStateContentModel ) */ @observable initState = null
    // /* @slot( TeamStateContentModel ) */ @observable states = []

    get: function get() {
      var warnings = [];
      if (!this.rounds.length) warnings.push("Missing rounds");
      if (!this.rounds.every(function (rnd) {
        return rnd.teamStates.length > 0 && rnd.teamStates.every(function (ts) {
          return ts.tasks.length > 0;
        });
      })) warnings.push("Round(s) missing teamstates/tasks");
      if (this.anyDirty) warnings.push("Simulation must be saved");
      if (this.isPublishDirty) warnings.push("Simulation must be published");
      return warnings;
    }
  }, {
    key: 'publishWarnings',
    get: function get() {
      var warnings = [];
      if (!this.rounds.length) warnings.push("Missing rounds");
      if (!this.rounds.every(function (rnd) {
        return rnd.teamStates.length > 0 && rnd.teamStates.every(function (ts) {
          return ts.tasks.length > 0;
        });
      })) warnings.push("Round(s) missing teamstates/tasks");
      if (this.anyDirty) warnings.push("Simulation must be saved");
      if (!this.isPublishDirty) warnings.push("Simulation already published");
      return warnings;
    }
  }, {
    key: 'SimDomainStore',
    get: function get() {
      var _desc2, _value2, _class3, _descriptor9;

      var self = this;
      return _class3 = function (_DomainStore) {
        (0, _inherits3.default)(SimDomainStore, _DomainStore);

        function SimDomainStore() {
          var _ref;

          var _temp2, _this4, _ret;

          (0, _classCallCheck3.default)(this, SimDomainStore);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp2 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref = SimDomainStore.__proto__ || (0, _getPrototypeOf2.default)(SimDomainStore)).call.apply(_ref, [this].concat(args))), _this4), _initDefineProp(_this4, 'inputs', _descriptor9, _this4), _temp2), (0, _possibleConstructorReturn3.default)(_this4, _ret);
        }

        return SimDomainStore;
      }(_simDomainStore2.default), (_descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'inputs', [_mobx.observable], {
        enumerable: true,
        initializer: function initializer() {
          return self.allSpecificInputs;
        }
      })), _class3;
    }

    // all inputs of the shell and its children, inputs of tasks and sub-sims are ignored since they are already managed
    // these inputs get put onto the SimDomainStore for this sim

  }, {
    key: 'allSpecificInputs',
    get: function get() {
      var collectedInputs = this.shell.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        var slot = parentCm.slots[slotName];
        if (Array.isArray(slot)) slot = slot[0];
        if (slot === SimulationContentModel) return false;
      }).map(function (ent) {
        return ent._inputs;
      }).concat(this.shell._inputs);

      return _cloner.shallow.merge.apply(_cloner.shallow, [{}].concat((0, _toConsumableArray3.default)(collectedInputs)));
    }
  }, {
    key: 'isPublishDirty',
    get: function get() {
      return !this.anyDirty && this.lastPublished < this.lastSaved;
    }
  }, {
    key: 'ShellContentModel',
    get: function get() {
      return this.shellType && this.shellType.module && this.shellType.module.ContentModel;
    }
  }, {
    key: 'shellDescription',
    get: function get() {
      return this.shellType && this.shellType.module && this.shellType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.displayName) invalid.displayName = "Please provide a display title!";
      if (!this.shellType) invalid.shellType = "Please choose a shellType";
      if (this.shell && this.shell.isNew && this.shell.allChildCms.length && this.shell.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.shell = "Please save all submodels";
      }
      return invalid;
    }
  }, {
    key: '_dtos',
    get: function get() {
      var _this5 = this;

      var states = {};
      var rounds = [];

      this.rounds.forEach(function (round, roundIndex, roundArr) {
        // handle teamstates
        var isFirstRound = roundIndex === 0;
        var isLastRound = roundIndex === roundArr.length - 1;
        var roundNumber = roundIndex + 1;
        round.teamStates.forEach(function (state, stateIndex, stateArr) {
          var isFirstState = stateIndex === 0;
          var isLastState = stateIndex === stateArr.length - 1;
          if (isFirstRound && isFirstState) {
            states["Init"] = {
              "title": "Init",
              "commands": {
                "enter": 'ResetTeam(TeamResetOptions.Default & ~TeamResetOptions.Num1);Team.Round = 1;TransitionTo("' + state.id + '");'
              }
            };
          }

          states[state.id] = {
            "title": state.displayName || state.id,
            "commands": state.runModel ? { "enter": 'RunModel("' + state.runModel + '", null, new XObject("actors", new object[] { new XObject("tag", "' + state.runModel + '", "saveOutputs", true) }));' } : {}
          };
          if (isFirstState && !isFirstRound) states[state.id].commands.enter = 'Team.Round = ' + roundNumber + ';';
          if (!(isLastState && isLastRound)) {
            var nextState = isLastState ? roundArr[roundIndex + 1].teamStates[0] : stateArr[stateIndex + 1];
            if (!nextState) return console.warn("round in simulation missing teamstate!" + _this5.id + " " + roundArr[roundIndex + 1].id);
            states[state.id].commands.advance = 'TransitionTo("' + nextState.id + '");';
          }
        });

        // add round to array
        rounds.push({
          "name": round.displayName || round.id,
          "beginTime": round.beginTime,
          "endTime": round.endTime
        });
      });

      return {
        "machine": {
          "type": 'MySimulation.' + this.id + ', MySimulation',
          // "procedures": {
          //   "computeScore": "O[\"Score\"] = 100;"
          // },
          "states": states
        },
        "scenario": {
          "title": this.displayName || this.id,
          "flow": this.id,
          "rounds": rounds
        }
      };
    }
  }, {
    key: 'readyToWriteToServer',
    get: function get() {
      return !(this.isNew //new
      || !this.rounds.length //no rounds
      || !(0, _keys2.default)(this._dtos.machine.states).length //no states
      );
    }
  }]);
  return SimulationContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  "displayName": "",
  "rounds": [_roundEntity.ContentModel],
  shell: _baseContentmodel2.default,
  shellType: RegisteredShellContentModel,
  lastSaved: 0,
  lastPublished: 0
}, _class2._meta = {
  lastSaved: {
    readonly: true
  },
  lastPublished: {
    readonly: true
  } }, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get shell() {
        var _this6 = this;

        return this.$parent.entities.values().filter(function (entity) {
          var shellType = _this6.shellType;

          return eval("shellType && shellType.ContentModelName === entity.type");
        });
      }
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'lastSaved', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'lastPublished', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'willPublish', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isPublishing', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPublishing'), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'shellType', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'shell', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Simulation Name";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'rounds', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'warnings', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'warnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'publishWarnings', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'publishWarnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SimDomainStore', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SimDomainStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allSpecificInputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allSpecificInputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveEntity', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPublishDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPublishDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'ShellContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'ShellContentModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shellDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'shellDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_dtos', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_dtos'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readyToWriteToServer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readyToWriteToServer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'exportToServer', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'exportToServer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createShell', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createShell'), _class.prototype)), _class));
var _default = SimulationContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegisteredShellContentModel, 'RegisteredShellContentModel', 'src/entity_modules/simulation-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(SimulationContentModel, 'SimulationContentModel', 'src/entity_modules/simulation-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/simulation-entity/contentmodel.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js
// module chunks = 0